module.exports = __webpack_public_path__ + "static/media/background-hall-817.e4dfd20e.png";